// extracted by css-extract-rspack-plugin
export default {"container":"PlgXsLjSvYlAv0El","holder":"MRkMqPZUk2AaCAxZ","overlay":"I70ccxnxGTAelcGo","verticalRule":"ruyPqimU_QgXoTpA"};